<div class="row" *ngIf="widgetType">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name" />
    </div>
  </div>
  <div class="col-lg-4 ">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group input-group-sm">
      <label>Refresh (Seconds)</label>
      <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval" />
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showLegend" /> Show Legend
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.stacked" /> Stacked Data
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showTimeSelect" /> Show Time Selection
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showCategories" /> Show Categories
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.hideWhenNoData" /> Hide Widget When No Series Found
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Left Axis</label>
      <div class="input-group">
        <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.leftMin" />
        <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.leftMax" />
        <input type="text" placeholder="units" class="form-control" [(ngModel)]="w.leftUnits" />
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Right Axis</label>
      <div class="input-group">
        <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.rightMin" />
        <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.rightMax" />
        <input type="text" placeholder="units" class="form-control" [(ngModel)]="w.rightUnits" />
      </div>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group input-group-sm">
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="input-group form-control  form-select">
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group input-group-sm">
      <label>Widget Height</label>
      <select [(ngModel)]="w.height" class="input-group form-control  form-select">
        <option value="100">100</option>
        <option value="150">150</option>
        <option value="200">200</option>
        <option value="250">250</option>
        <option value="300">300</option>
        <option value="350">350</option>
        <option value="400">400</option>
        <option value="450">450</option>
        <option value="500">500</option>
        <option value="550">550</option>
      </select>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group input-group-sm">
      <label>No Data Message</label>
      <input min="60" type="text" placeholder="No Data Message" class="form-control" [(ngModel)]="w.noDataMessage" />
    </div>
  </div>
</div>

<hr class="mb-4">

<div class="row mb-3">
  <div class="col-lg-3">
    <button (click)="addTimeSeries()" class="btn btn-primary btn-block" type="submit">
      <i class="fa fa-line-chart"></i> Add Time Series
    </button>
  </div>
  <div class="col-lg-3">
    <button (click)="addBand()" class="btn btn-primary btn-block" type="submit">
      <i class="fa fa-bars"></i> Add Band
    </button>
  </div>
  <div class="col-lg-3">
    <button (click)="addLine()" class="btn btn-primary btn-block" type="submit">
      <i class="fa fa-minus"></i> Add Line
    </button>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <tabset>
      <tab *ngFor="let tab of w.timeSeriesDetailList"
        [heading]="tab.uri == null && tab.displayName == null ? 'Not Set' : tab.displayName == '' || tab.displayName == null ? tab.uri : tab.displayName"
        [active]="tab.active" (select)="tab.active = true" (deselect)="tab.active = false" [disabled]="tab.disabled"
        [removable]="tab.removable" (removed)="removeTimeSeries(tab)">
        <div class="row">
          <div class="col-lg-7">
            <div class="row mt-3">
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Select Time Series
                    <button [style.background]="tab.colour" [cpPosition]="'bottom'" [(colorPicker)]="tab.colour"
                      [cpPresetLabel]="'Standard'" [cpPresetColors]="app.colours" class="colour-picker-button"></button>
                  </label>
                  <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="false" 
                    [enableTagMatch]="true" [enableMultiSelect]="true" [siteTypeCode]="dashboard.siteType" 
                    [siteUri]="siteUri"></app-uri-select>
                  <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group input-group-sm">
                  <label>Display Name</label>
                  <input type="text" size="20" [(ngModel)]="tab.displayName" class="form-control" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group input-group-sm">
                  <label>Series Type</label>
                  <select [(ngModel)]="tab.type" class="group-select m-b form-select">
                    <option value="line">Line</option>
                    <option value="stepline">Step Line</option>
                    <option value="spline">Spline</option>
                    <option value="area">Area</option>
                    <option value="areaspline">AreaSpline</option>
                    <option value="column">Column</option>
                    <option value="bar">Bar</option>
                    <option value="scatter">Scatter</option>
                    <!--<option value="stackarea">Stacked Area</option>
                    <option value="stackareaspline">Stacked Area Spline</option>
                    <option value="stackcolumn">Stacked Column</option>-->
                  </select>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group input-group-sm">
                  <label>Axis</label>
                  <select [(ngModel)]="tab.axis" class="group-select m-b form-select">
                    <option value="0">Left</option>
                    <option value="1">Right</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4" *ngIf="tab.type != 'scatter'">
                <div class="form-group input-group-sm">
                  <label>Style</label>
                  <select [(ngModel)]="tab.style" class="group-select m-b form-select">
                    <option value="solid">Solid</option>
                    <option value="shortdash">Short Dash</option>
                    <option value="ShortDot">Short Dot</option>
                    <option value="ShortDashDot">Short Dash Dot</option>
                    <option value="ShortDashDotDot">Short Dash Dot Dot</option>
                    <option value="Dot">Dot</option>
                    <option value="Dash">Dash</option>
                    <option value="LongDash">Long Dash</option>
                    <option value="DashDot">Dash Dot</option>
                    <option value="LongDashDot">Long Dash Dot</option>
                    <option value="LongDashDotDot">Long Dash Dot Dot</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group input-group-sm" *ngIf="tab.type != 'scatter'">
                  <label>Show Marker</label>
                  <select [(ngModel)]="tab.showMarker" class="group-select m-b form-select">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div class="form-group input-group-sm" *ngIf="tab.type != 'scatter'">
                  <label>Only Show When Selected</label>
                  <select [(ngModel)]="tab.showWhenSelected" class="group-select m-b form-select">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div class="form-group input-group-sm" *ngIf="tab.type == 'scatter'">
                  <label>Marker Type</label>
                  <select [(ngModel)]="tab.markerType" class="group-select m-b form-select">
                    <option value="circle">Circle</option>
                    <option value="square">Square</option>
                    <option value="triangle">Triangle</option>
                    <option value="triangle-down">Inverted Triangle</option>
                    <option value="diamond">Diamond</option>
                  </select>
                </div>
                
              </div>
              <div class="col-lg-3">
                <div class="form-group input-group-sm">
                  <label>Size</label>
                  <select [(ngModel)]="tab.size" class="group-select m-b form-select">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-3">
                <div class="form-group input-group-sm">
                  <label>Custom Tooltips</label> <br>
                  <input type="checkbox" [(ngModel)]="tab.customTooltip" /> Enabled
                </div>
              </div>

              <div class="col-lg-3" *ngIf="tab.customTooltip">
                <label>Metadata Names <button (click)="addMetaTag(tab)" type="button" class="btn btn-primary p-0"><i class="bi bi-plus-lg"></i></button></label>
                <div class="form-group input-group" *ngFor="let tag of tab.customTooltipTags; let i = index">
                  
                  <div class="d-flex">
                    <input class="m-1" type="text" [(ngModel)]="tag.metaTag" placeholder="Metadata Tag" (ngModelChange)="logChange(tag)" required>
                    <input class="m-1" type="text" [(ngModel)]="tag.displayName" placeholder="Display Name" (ngModelChange)="logChange(tag)" required>
                    <div><button (click)="removeMetaTag(tab,i)" type="button" class="btn btn-primary px-0 py-1"><i class="bi bi-dash-lg"></i></button></div>
                  </div>

                </div>
              </div>

              <div class="col-lg-3" *ngIf="w.showCategories">
                <div class="form-group input-group-sm">
                  <label>Display Value</label>
                  <select [(ngModel)]="tab.displayValue" class="group-select m-b form-select">
                    <option value="min">Min</option>
                    <option value="max">Max</option>
                    <option value="average">Average</option>
                    <option value="count">Count</option>
                    <option value="sum">Sum</option>
                    <option value="sumPercentage">Sum Percentage</option>
                    <option value="countPercentage">Count Percentage</option>
                  </select>
                </div>
              </div>
            </div>


            <div class="row mt-3">
              <div class="col-12">
                <button class="btn btn-primary" (click)="duplicate(tab)">Duplicate Entry</button>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
          </div>
        </div>

      </tab>
      <tab *ngFor="let tab of w.bandDetailList" [heading]="tab.name == null ? 'Not Set' : tab.name"
        [active]="tab.active" (select)="tab.active = true" (deselect)="tab.active = false" [disabled]="tab.disabled"
        [removable]="true" (removed)="removeBand(tab)">
        <div class="row mt-3">
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Name</label>
              <input type="text" [(ngModel)]="tab.name" />
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Min</label>
              <input type="text" [(ngModel)]="tab.min" />
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Max</label>
              <input type="text" [(ngModel)]="tab.max" />
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Colour</label>
              <!-- todo - colour picker library? -->
              <input type="string" [(colorPicker)]="tab.colour" [style.background]="tab.colour"
                [cpPosition]="'bottom'" />
            </div>
          </div>
        </div>
      </tab>
      <tab *ngFor="let tab of w.lineDetailList" [heading]="tab.name == null ? 'Not Set' : tab.name"
        [active]="tab.active" (select)="tab.active = true" (deselect)="tab.active = false" [disabled]="tab.disabled"
        [removable]="true" (removed)="removeLine(tab)">
        <div class="row mt-3">
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Name</label>
              <input type="text" [(ngModel)]="tab.name" />
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Value</label>
              <input type="text" [(ngModel)]="tab.value" />
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Colour</label>
              <input type="string" [(colorPicker)]="tab.colour" [style.background]="tab.colour"
                [cpPosition]="'bottom'" />
            </div>
          </div>
        </div>
      </tab>
    </tabset>
  </div>
</div>